import axios from 'axios';
import { Notify } from 'vant';
import i18n from '@/i18n';
import router from '@/router';

const config = process.env.NODE_ENV === 'development' ? window.config.dev : window.config.prod;

const instance = axios.create({
  baseURL: config.baseURL,
  timeout: '30000',
  headers: {
    'Content-Type': 'application/json;',
  },
});

instance.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.token = `Bearer ${token}`;
  }

  return config;
});

instance.interceptors.response.use(
  response => {
    try {
      switch (response?.status) {
        case 200:
          if (response.data.respCode === 10000000) {
            return [true, response.data];
          } else if (response.data.respCode < 15000000 && response.data.respCode > 14000000) {
            sessionStorage.clear();
            router.push({ name: 'login' });
            return [false, response.data];
          } else {
            Notify(i18n.tc(response.data.respCode?.toString()));
            return [false, response.data];
          }
        case 401:
          router.push({ name: 'login' });
          return [false, response.data];
        default:
          Notify(i18n.tc(response.data.code));
          return [true, response.data];
      }
    } catch (error) {
      return [false, response.data];
    }
  },
  function(error) {
    switch (error?.response?.status) {
      case 401:
        router.push({ name: 'login' });
        return [false, error?.response?.data];
      default:
    }
    return Promise.reject(error);
  }
);

export default instance;
